export const TERMS_AND_CONDITIONS_LINK = 'https://grundfos.com/legal/grundfos-customer-terms.html';
export const TERMS_OF_USE_LINK = 'https://www.grundfos.com/ke/legal/terms-of-use#user-account';
